import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});


const linkA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
}: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}) => ({
  color: '#fff', // Azul padrão para links
  textDecoration: 'none', // Remove sublinhado padrão
  fontSize: isMobileMini ? '13px' : isMobileMedium ? '14px' : isMobileBig ? '16px' : isMiniNotebook ? '18px' : '18px',
  width: isMobileMini ? '150px' : isMobileMedium ? '160px' : isMobileBig ? '175px' : isMiniNotebook ? '220px' : '250px',
  display: "inline-block",
  padding: "10px 15px",
  backgroundColor: "#007bff", // Cor de botão (altere conforme necessário)
  borderRadius: "5px",
  textAlign: "center",
  fontWeight: "bold",
  transition: "background-color 0.3s",
  margin: "0 auto",
  
  ':hover': {
    color: '#0056b3', // Azul mais escuro no hover
    textDecoration: 'underline',
  },
  
  ':active': {
    color: '#004494', // Azul ainda mais escuro no clique
  }
});

const textC = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});


const divC = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '420px': isMobileBig ? '450px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '450px' : '500px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})


const imageB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '240px': isMobileMedium ? '380px': isMobileBig ? '360px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '300px' : '320px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

export const card_17_01_25 = {

  date: '17-01-2025',
  routeCard: '/produtos/secaps-black/17-01-2025',
  description: 'Secaps Black é o melhor produto para emagrecimento de forma natural',
  month: 'Janeiro',
  shortTitle: 'Secaps Black: Cápsulas de Emagrecimento.',
  elements: [
    {
      type: 'title',
      content: 'Secaps Black: Cápsulas de Emagrecimento.',
      getStyles: titleA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.SecapsBlack_17_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brC,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          Secaps Black é um ótimo aliado no emagrecimento, por ser termogênico ele auxilia no metabolismo e gasto calórico.
          Sua formulação é uma combinação de igredientes naturais que promovem o emagrecimento de forma natural e eficaz.
          Ele tambem ajuda na redução do apetite e ansiedade, aumentando a saciedade.
          </p>
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.EmagrecendoSecaps_17_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'title',
          content: 'Emagrecimento Natural com Secaps Black',
          getStyles: titleA,
        },
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">O Secaps Black possui igredientes 100% naturais e testados, comprovando sua eficácia.
          Um produto regularizado pela anvisa e que atende os mais altos padrões de qualidade. 
          Um produto ideal para quem deseja reduzir medidas nas áreas como culote, barriga, pernas e braços, lugares que mais sujeitos ao acumulo de gordura. 
          </p>
          `,
          getStyles: textB,
        },
        {
          type: 'text',
          content: 'Principais benefícios do Secaps Black:',
          getStyles: textB,
        },
        {
          type: 'list',
          content: [
           'Acelera o metabolismo – Ajuda a queimar calorias de forma mais eficiente.',
           'Queima de gordura – Auxilia na redução de medidas e no emagrecimento.',
           'Regula o organismo – Contribui para o bom funcionamento do sistema digestivo.',
           'Fórmula natural – Com ingredientes selecionados para oferecer resultados seguros.',
          ],
          getStyles: listA,          
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
      ],
      getStyles: divB,
    },
        {
          type: 'div',
          content: [
            {
              type: 'title',
              content: '04 POTES SECAPS BLACK - 4 Meses',
              getStyles: titleA,
            },
            {
            type: 'div',
            content: [
              {
              type: 'div',
              content: [
                {
                  type: 'text',
                 content: `
                  <p style="text-indent: 20px;">
                  Neste Kit com 4 potes Secaps vem com a quantidade suficiente para 4 meses, ingerindo 2 cápsulas ao dia. De preferencia junto às refeições.   
                 </p>
                  `,
                  getStyles: textC,
                },
                {
                  type: 'text',
                  content: `
                   <p style="text-indent: 20px;">
                   Garanta já com um super desconto, basta acessar o link:  
                  </p>
                   `,
                   getStyles: textC, 
                },
                {
                  type: 'link',
                  content: 'https://amzn.to/43smpxx',
                  label: "Link para a compra",
                  getStyles: linkA,
                },
                {
                  type: 'br',
                  content: '',
                  getStyles: brA,
                },
              ],
              getStyles: divC,
              },
              {
                type: 'image',
                content: cardImages.SecapsInfo_17_01_25,
                getStyles: imageB,
              },
            ],
            getStyles: divA,
            },
          ],
          getStyles: divB,
        },
  ] as ElementType[],
  tags: ['produtos', 'emagrecimento', 'secaps', 'cápsulas'],
  author: 'John Doe',
}

